/**
 * Checks if the passed charValue is found within
 * the passed stringValue
 *
 * @param {String} stringValue
 * @param {String} charValue
 */
export function contains(stringValue, charValue) {
    return stringValue.indexOf(charValue) > -1;
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/contains.js